import { errorHandler } from 'client/helpers/errorHandler';
import { IThunkAction } from 'types/IThunkAction';
import { startLoading, stopLoading } from 'client/_redux/actions/loading';
import * as tourServices from 'dashboard/_redux/services/tours';
import { ITour, ITourFormValues, ITourStep } from 'client/models/ITour';
import { ToursDashboardTypes } from 'dashboard/_redux/types/toursDashboardTypes';
import { toast } from 'react-toastify';
import { SearchQuery } from '../users';

export const getAllToursDashboard = (
  searchQuery: SearchQuery<ITour>,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());
  dispatch({ type: ToursDashboardTypes.FETCH_TOURS_START });
  try {
    console.log('🔄 Chargement des tours avec query:', searchQuery);
    const tours = await tourServices.getAllTours()(searchQuery);
    console.log('✅ Tours chargés avec succès:', tours);

    dispatch({
      type: ToursDashboardTypes.FETCH_TOURS_SUCCESS,
      payload: tours,
    });
  } catch (error) {
    console.error('❌ ERREUR lors du chargement des tours:', error);
    console.error('❌ Détails de l\'erreur:', {
      message: error.message,
      response: error.response,
      stack: error.stack,
    });
    dispatch({ type: ToursDashboardTypes.FETCH_TOURS_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const getTourDashboardById = (tourId: string): IThunkAction => async (
  dispatch,
) => {
  dispatch(startLoading());
  dispatch({ type: ToursDashboardTypes.UPDATE_TOUR_START });
  try {
    const tour = await tourServices.getTourById()(tourId);

    dispatch({
      type: ToursDashboardTypes.UPDATE_TOUR_SUCCESS,
      payload: tour,
    });
  } catch (error) {
    dispatch({ type: ToursDashboardTypes.UPDATE_TOUR_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const updateTourDashboard = (
  tourId: string,
  values: Partial<ITourFormValues>,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());
  dispatch({ type: ToursDashboardTypes.UPDATE_TOUR_START });
  try {
    const tour = await tourServices.updateTour()(values, tourId);

    toast('Tour modifié avec succès!', { type: 'success' });

    dispatch({
      type: ToursDashboardTypes.UPDATE_TOUR_SUCCESS,
      payload: tour,
    });
  } catch (error) {
    dispatch({ type: ToursDashboardTypes.UPDATE_TOUR_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const deleteTourDashboard = (
  tourId: string,
  onSuccess?: () => void,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());

  try {
    await tourServices.deleteTourById()(tourId);
    toast('Tour supprimé avec succès!', { type: 'success' });
    onSuccess?.();
  } catch (error) {
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const createTourDashboard = (values: ITourFormValues): IThunkAction => async (dispatch) => {
  dispatch(startLoading());

  try {
    await tourServices.createTour()(values);
    toast('Tour créé avec succès!', { type: 'success' });
  } catch (error) {
    const maybeAxiosError = error as any;
    const firstValidationErrorMessage = maybeAxiosError?.response?.data?.errors?.[0]?.msg;
    if (firstValidationErrorMessage) {
      toast(firstValidationErrorMessage, { type: 'error' });
    }
    errorHandler(error);
    throw error;
  }
  dispatch(stopLoading());
};

// Actions pour la gestion des étapes
export const addStepToTourDashboard = (
  tourId: string,
  stepData: Omit<ITourStep, 'order'>,
  onSuccess?: () => void,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());

  try {
    const tour = await tourServices.addStepToTour()(tourId, stepData);
    toast('Étape ajoutée avec succès!', { type: 'success' });
    
    dispatch({
      type: ToursDashboardTypes.UPDATE_TOUR_SUCCESS,
      payload: tour,
    });
    
    onSuccess?.();
  } catch (error) {
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const updateStepInTourDashboard = (
  tourId: string,
  stepOrder: number,
  stepData: Partial<ITourStep>,
  onSuccess?: () => void,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());

  try {
    const tour = await tourServices.updateStepInTour()(tourId, stepOrder, stepData);
    toast('Étape modifiée avec succès!', { type: 'success' });
    
    dispatch({
      type: ToursDashboardTypes.UPDATE_TOUR_SUCCESS,
      payload: tour,
    });
    
    onSuccess?.();
  } catch (error) {
    errorHandler(error);
  }
  dispatch(stopLoading());
};

export const deleteStepFromTourDashboard = (
  tourId: string,
  stepOrder: number,
  onSuccess?: () => void,
): IThunkAction => async (dispatch) => {
  dispatch(startLoading());

  try {
    const tour = await tourServices.deleteStepFromTour()(tourId, stepOrder);
    toast('Étape supprimée avec succès!', { type: 'success' });
    
    dispatch({
      type: ToursDashboardTypes.UPDATE_TOUR_SUCCESS,
      payload: tour,
    });
    
    onSuccess?.();
  } catch (error) {
    errorHandler(error);
  }
  dispatch(stopLoading());
};
